import React from 'react';
import { useDebouncedCallback } from '@tanstack/react-pacer';

import { Camera } from 'types/camera';

import { UseCamerasParams, useCameras } from 'cameras/hooks/useCameras';

import { Select, SelectProps } from 'components/Select/Select';

export type CameraSelectProps<IsMulti extends boolean = false> = SelectProps<
  Camera,
  IsMulti
> & {
  queryFilters?: UseCamerasParams;
};

export function CameraSelect<IsMulti extends boolean = false>({
  placeholder = 'Camera',
  isLoading,
  queryFilters = {},
  ...props
}: CameraSelectProps<IsMulti>) {
  const [filters, setFilters] = React.useState<UseCamerasParams>({});

  const { data, isLoading: isLoadingOptions } = useCameras({
    params: { ...queryFilters, ...filters },
    keepPreviousData: true,
  });

  const handleInputChange = useDebouncedCallback(
    (value: string) => {
      setFilters((previousFilters) => ({
        ...previousFilters,
        camera_names: [value],
      }));
    },
    { wait: 100 }
  );

  return (
    <Select
      {...props}
      options={data?.data}
      totalElements={data?.total_elements}
      onInputChange={handleInputChange}
      getOptionLabel={({ name }) => name}
      getOptionValue={({ id }) => id}
      isLoading={isLoading || isLoadingOptions}
      placeholder={placeholder}
    />
  );
}
